import { NgIf, NgStyle } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IHeaderAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'cv-cxone-order-management-header',
  standalone: true,
  imports: [NgStyle, MatTooltipModule, NgIf],
  templateUrl: './cxone-order-management-header.component.html',
  styleUrl: './cxone-order-management-header.component.scss'
})
export class CxoneOrderManagementHeaderComponent implements IHeaderAngularComp {
  params: any;
  sort: string;
  ascSort: boolean;
  descSort: boolean;
  id: string;
  hidePopover: boolean;

  @ViewChild('menuButton', { read: ElementRef }) public menuButton!: ElementRef;

  constructor(private cdr : ChangeDetectorRef) { }
  agInit(params: any): void {
      this.params = params;
      this.sort = this.params.column.sort != null ? this.params.column.sort : "";
      this.ascSort = this.sort === "asc";
      this.descSort = this.sort === "desc";
      this.id =  this.params.column.colId;
      this.onColumnResized();
      params.column.addEventListener('sortChanged', this.onSortChanged.bind(this));
      params.api.addEventListener('columnResized', this.onColumnResized.bind(this));
  }

  refresh(params: any) {
      this.params = params;
      this.sort = this.params.column.sort != null ? this.params.column.sort : "";
      this.ascSort = this.sort === "asc";
      this.descSort = this.sort === "desc";
      this.id =  this.params.column.colId;
      return true;
  }

  onMenuClicked() {
      this.params.showColumnMenu(this.menuButton.nativeElement);
  }

  onSortChanged() {
      this.sort = this.params.column.sort != null ? this.params.column.sort : "";
      this.ascSort = this.sort === "asc";
      this.descSort = this.sort === "desc";
  }

  onSortRequested(event: any) {
      if (this.params.enableSorting) {
      let order = "";
      if (this.sort === "") {
          order = "asc";
      } else if (this.sort === "asc") {
          order = "desc";
      }
      this.params.setSort(order, event.shiftKey);
      }
  }

  onColumnResized() {
      //check if text overflows
      var el = document.getElementById(this.id);
      if (el && el.scrollWidth <= el.offsetWidth) {
          this.hidePopover = true;
      }
      else {
          this.hidePopover = false;
      }
  }

  isTextHasEllipsis(element: HTMLElement): boolean {
    return element.scrollWidth > element.clientWidth;
  }
}
